import { FormInput } from '@/components/forms/FormInput';
import { FormOptionalNumericInput } from '@/components/forms/FormOptionalNumericInput';

export function IngredientNutritionFields({ size }) {
  return (
    <>
      <FormInput
        name="kcal"
        label="Kcal"
        type="number"
        size={size}
        inputProps={{ min: 0, step: 0.01 }}
      />
      <FormInput
        name="fat"
        label="Fat (g)"
        type="number"
        size={size}
        inputProps={{ min: 0, step: 0.01 }}
      />
      <FormInput
        name="carbs"
        label="Carbs (g)"
        type="number"
        size={size}
        inputProps={{ min: 0, step: 0.01 }}
      />
      <FormInput
        name="protein"
        label="Protein (g)"
        type="number"
        size={size}
        inputProps={{ min: 0, step: 0.01 }}
      />
      <FormInput
        name="fiber"
        label="Fiber (g)"
        type="number"
        size={size}
        inputProps={{ min: 0, step: 0.01 }}
      />
      <FormInput
        name="density"
        label="Density (g/ml)"
        type="number"
        size={size}
        inputProps={{ min: 0, step: 0.01 }}
      />
      <FormOptionalNumericInput
        name="piece_weight"
        label="Piece Weight (g)"
        size={size}
        inputProps={{ min: 0, step: 0.01 }}
      />
      <FormOptionalNumericInput
        name="slice_weight"
        label="Slice Weight (g)"
        size={size}
        inputProps={{ min: 0, step: 0.01 }}
      />
      <FormOptionalNumericInput
        name="package_size"
        label="Package Size (g)"
        size={size}
        inputProps={{ min: 0, step: 0.01 }}
      />
      <FormOptionalNumericInput
        name="portion_size"
        label="Portion Size (g)"
        size={size}
        inputProps={{ min: 0, step: 0.01 }}
      />
    </>
  );
}
